import { render } from "./contacts.vue?vue&type=template&id=7618275c&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"

import "./contacts.vue?vue&type=style&index=0&id=7618275c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7618275c"]])

export default __exports__